module.exports = __webpack_public_path__ + "static/img/qrsxp-BlilOf5v.c936adc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/qrsxp-BlilOf5v.png
// module id = hHSi
// module chunks = 16